import Flickity from 'flickity';
import * as breakpoint from '@pixelunion/breakpoint';
import EventHandler from '@pixelunion/events';
import FlickityA11yPatch from '../utils/FlickityA11yPatch';

export default class DynamicLogoList {
  constructor(section) {
    this.el = section.el;
    this.settings = section.data;
    this.events = new EventHandler();

    this.carousel = this.el.querySelector('[data-logo-list-wrapper]');
    this.slides = this.el.querySelectorAll('[data-logo-list-logo]');
    this.mobile_layout = this.settings.mobile_layout;

    this.onBreakpointChange = () => {
      if (this.mobile_layout === 'slider' && breakpoint.max('S') && this.slides.length > 2) {
        this._initFlickity();
      } else {
        this._destroyFlickity();
      }
    };

    this.onBreakpointChange();

    breakpoint.onChange(this.onBreakpointChange);
  }

  _initFlickity() {
    if (this.Flickity) {
      return;
    }

    this.flickity = new Flickity(this.carousel, {
      autoPlay: false,
      pageDots: true,
      prevNextButtons: false,
      cellAlign: 'left',
      groupCells: true,
      wrapAround: true,
      dragThreshold: 10,
    });

    this.flickityA11yPatch = new FlickityA11yPatch(this.carousel);

    this.events.register(this.carousel, 'rimg:load', () => {
      this.flickity.resize();
    });
  }

  _destroyFlickity() {
    if (!this.flickity) {
      return;
    }

    this.flickity.destroy();
    this.flickity = null;
  }

  onSectionUnload() {
    this._destroyFlickity();

    if (this.flickityA11yPatch) {
      this.flickityA11yPatch.unload();
    }

    breakpoint.offChange(this.onBreakpointChange);
    this.events.unregisterAll();
  }
}
